import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-ads',
  templateUrl: './ads.component.html',
  styleUrls: ['./ads.component.css'],
})
export class AdsComponent {
  url: string = 'googleAds';
  data: Array<any> = [];
  campaigns: Array<any> = [];
  groups: Array<any> = [];
  keywords: Array<any> = [];
  metrics: Array<any> = [];
  step = 1;

  resumenCards = [
    {
      label: '',
      value: '',
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/marketing/mediaroom',
    },
    
  ];
  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.dataService.getData(this.url).subscribe((response) => {
      console.log('response en ads', response);

      if (response) {
        this.campaigns = response.campaigns;
        this.groups = response.groups;
        this.keywords = response.keywords;
        this.metrics = response.metrics;
      } else {
        this.messageService.add(response.msg, 'secondary');
      }
    });
  }

  changeStep(step: number) {
    this.step = step;
  }
}
